<template>
  <div class="main train-plan-page">
    <div class="main_r" ref="pageBody">
      <el-tabs
        v-model="activeName"
        style="width: 100%; height: 100%;"
        :before-leave="beforeTabLeave"
      >
        <el-tab-pane label="训练计划列表" name="first">
          <div class="page-top">
            <div class="title_line">训练计划列表</div>

            <div class="filter-strip">
              <div class="filter-strip__fields">
                <div class="filter-field">
                  <label class="filter-field__label">训练计划分类</label>
                  <el-select v-model="queryData.trainPlanClassification" placeholder="全部" size="small">
                    <el-option label="全部" value="0"></el-option>
                    <el-option v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                  </el-select>
                </div>
                <div class="filter-field">
                  <label class="filter-field__label">训练计划名称</label>
                  <el-input v-model="queryData.trainPlanName" placeholder="输入名称" clearable size="small"></el-input>
                </div>
                <div class="filter-field">
                  <label class="filter-field__label">训练计划难度</label>
                  <el-select v-model="queryData.trainPlanDifficulty" placeholder="全部" size="small">
                    <el-option label="全部" value="0"></el-option>
                    <el-option v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                  </el-select>
                </div>
                <div class="filter-field">
                  <label class="filter-field__label">训练计划类型</label>
                  <el-select v-model="queryData.trainPlanType" placeholder="全部" size="small">
                    <el-option label="全部" value="0"></el-option>
                    <el-option v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                  </el-select>
                </div>
                <div class="filter-field">
                  <label class="filter-field__label">首页推荐</label>
                  <el-select v-model="queryData.isHome" placeholder="全部" size="small">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </div>
                <div class="filter-field">
                  <label class="filter-field__label">Banner推荐</label>
                  <el-select v-model="queryData.isBanner" placeholder="全部" size="small">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="filter-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
                <span class="filter-strip__sep"></span>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAdd">新增</el-button>
                <el-button type="success" size="small" icon="el-icon-upload2" @click="clickBatchAdd">批量新增</el-button>
              </div>
            </div>
          </div>

          <!-- 列表 -->
          <div class="table-section" ref="tableSection">
            <div class="table-container" ref="tableContainer">
              <el-table ref="trainPlanTable" :data="dataList" class="train-plan-table" :height="tableHeight" :header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle" @sort-change="handleSortChange">
                <el-table-column type="index" label="序号" width="70" fixed="left" align="center" :index="tableIndexMethod"></el-table-column>
                <el-table-column prop="trainPlanClassification" label="计划分类" min-width="120" sortable="custom" align="center">
                  <template slot-scope="props">
                    {{props.row.trainPlanClassification}}周
                  </template>
                </el-table-column>
                <el-table-column prop="trainPlanTypeUi" label="计划类型" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="trainPlanWeekNum" label="每周训练次数" min-width="130" sortable="custom" align="center">
                  <template slot-scope="props">
                    {{props.row.trainPlanWeekNum}}次
                  </template>
                </el-table-column>
                <el-table-column prop="trainPlanTime" label="计划时长" min-width="130" sortable="custom" align="center">
                  <template slot-scope="props">
                    {{props.row.trainPlanTime}}分钟
                  </template>
                </el-table-column>
                <el-table-column prop="trainPlanName" label="计划名称" min-width="160" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column label="列表封面" width="90" align="center">
                  <template v-slot="scope">
                    <el-image v-if="scope.row.trainPlanIconUi" style="width: 40px; height: 40px; border-radius: 4px;" :src="scope.row.trainPlanIconUi" :preview-src-list="[scope.row.trainPlanIconUi]" fit="cover"></el-image>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="详情页封面" width="100" align="center">
                  <template v-slot="scope">
                    <el-image v-if="scope.row.trainPlanIconDetailsUi" style="width: 40px; height: 40px; border-radius: 4px;" :src="scope.row.trainPlanIconDetailsUi" :preview-src-list="[scope.row.trainPlanIconDetailsUi]" fit="cover"></el-image>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="Banner封面" min-width="120" align="center">
                  <template v-slot="scope">
                    <el-image v-if="scope.row.trainPlanIconBannerUi" style="width: 40px; height: 40px; border-radius: 4px;" :src="scope.row.trainPlanIconBannerUi" :preview-src-list="[scope.row.trainPlanIconBannerUi]" fit="cover"></el-image>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="trainPlanDifficultyUi" label="计划难度" min-width="120" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="isHome" label="首页推荐" min-width="130" sortable="custom" align="center">
                  <template slot-scope="props">
                    <el-tag :type="props.row.isHome == 1 ? 'success' : 'info'" size="small" effect="plain">{{ props.row.isHome == 1 ? '是' : '否' }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="isBanner" label="Banner推荐" min-width="140" sortable="custom" align="center">
                  <template slot-scope="props">
                    <el-tag :type="props.row.isBanner == 1 ? 'warning' : 'info'" size="small" effect="plain">{{ props.row.isBanner == 1 ? '是' : '否' }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
                <el-table-column label="英文名称" min-width="180" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="text-muted">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['train_plan_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="德文名称" min-width="180" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="text-muted">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['train_plan_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Operation" label="操作" width="150" fixed="right" align="center">
                  <template slot-scope="scope">
                    <div class="action-group"><el-tooltip effect="dark" content="编辑" placement="top" :enterable="false"><el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-link></el-tooltip><el-tooltip effect="dark" content="删除" placement="top" :enterable="false"><el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link></el-tooltip><el-tooltip effect="dark" content="安排周日程" placement="top" :enterable="false"><el-link :underline="false" type="primary" icon="el-icon-view" @click="gotoWebTwoTrainPlanDatabaseSub(scope.row)"></el-link></el-tooltip><el-tooltip effect="dark" content="翻译" placement="top" :enterable="false"><el-link :underline="false" type="warning" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link></el-tooltip></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="total, prev, pager, next, sizes, jumper"
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </el-tab-pane>

        <!-- 安排每周训练日程 start -->
        <el-tab-pane :label="TabSecondTitle" name="second" style="height: 100%;">
          <WebTwoTrainPlanDatabaseSub ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></WebTwoTrainPlanDatabaseSub>
        </el-tab-pane>
        <!-- 安排每周训练日程 end -->
      </el-tabs>

      <!---------------------- 以下是弹框内容 ---------------------->
      <!-- 新增计划 -->
          <el-dialog title="添加计划" :visible.sync="dialogAdd" width="720px" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
            <div class="addUser_body">
              <el-form ref="userMsg" :model="addData" label-width="150px">
                <el-form-item label="训练计划分类" :required=true>
                  <el-select v-model="addData.trainPlanClassification" placeholder="训练计划分类">
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划类型" :required=true>
                  <el-select v-model="addData.trainPlanType" multiple placeholder="训练计划类型">
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划难度" :required=true>
                  <el-select v-model="addData.trainPlanDifficulty" placeholder="训练计划难度">
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划名称" :required=true>
                  <el-input v-model="addData.trainPlanName" placeholder="请输入训练计划名称"></el-input>
                </el-form-item>
                <el-form-item label="列表封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddTrainPlanIconUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="addData.trainPlanIconUi || addData.trainPlanIcon" :src="addData.trainPlanIconUi || getImageUrl(addData.trainPlanIcon)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="详情页封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddTrainPlanIconDetailsUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="addData.trainPlanIconDetailsUi || addData.trainPlanIconDetails" :src="addData.trainPlanIconDetailsUi || getImageUrl(addData.trainPlanIconDetails)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="Banner封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddTrainPlanIconBannerUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="addData.trainPlanIconBannerUi || addData.trainPlanIconBanner" :src="addData.trainPlanIconBannerUi || getImageUrl(addData.trainPlanIconBanner)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="每周训练次数" :required=true>
                  <el-input v-model="addData.trainPlanWeekNum" placeholder="请输入每周训练次数">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">是</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="训练计划简介" :required=true>
                  <el-input type="textarea" v-model="addData.trainPlanInfo" placeholder="请输入训练计划简介"></el-input>
                </el-form-item>
                <el-form-item label="首页推荐" :required=true>
                  <el-select v-model="addData.isHome" placeholder="首页推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Banner推荐" :required=true>
                  <el-select v-model="addData.isBanner" placeholder="Banner推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐标题" :required=true>
                  <el-input v-model="addData.bannerTitle" placeholder="请输入推荐标题"></el-input>
                </el-form-item>
                <el-form-item label="推荐描述" :required=true>
                  <el-input type="textarea" v-model="addData.bannerDescription" placeholder="请输入推荐描述"></el-input>
                </el-form-item>
                <el-divider content-position="left">运动处方标签</el-divider>
                <el-form-item label="适合性别">
                  <el-select v-model="addData.dimSex" multiple placeholder="不选则不限">
                    <el-option label="男" value="A"></el-option>
                    <el-option label="女" value="B"></el-option>
                    <el-option label="秘密" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合年龄段">
                  <el-select v-model="addData.dimAge" multiple placeholder="不选则不限">
                    <el-option label="少年(6-13)" value="A"></el-option>
                    <el-option label="青年(14-17)" value="B"></el-option>
                    <el-option label="成年(18-40)" value="C"></el-option>
                    <el-option label="大师(41-64)" value="D"></el-option>
                    <el-option label="银发(65+)" value="E"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练经验">
                  <el-select v-model="addData.dimExperience" multiple placeholder="不选则不限">
                    <el-option label="新手(<2月)" value="A"></el-option>
                    <el-option label="入门(2-6月)" value="B"></el-option>
                    <el-option label="熟练(6-12月)" value="C"></el-option>
                    <el-option label="进阶(>2年)" value="D"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练频率">
                  <el-select v-model="addData.dimFrequency" multiple placeholder="不选则不限">
                    <el-option label="低频(1-2次/周)" value="A"></el-option>
                    <el-option label="常规(3-4次/周)" value="B"></el-option>
                    <el-option label="高频(5+次/周)" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练强度">
                  <el-select v-model="addData.dimIntensity" multiple placeholder="不选则不限">
                    <el-option label="低强" value="A"></el-option>
                    <el-option label="中强" value="B"></el-option>
                    <el-option label="高强" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合技术熟练度">
                  <el-select v-model="addData.dimSkill" multiple placeholder="不选则不限">
                    <el-option label="无基础" value="A"></el-option>
                    <el-option label="基础" value="B"></el-option>
                    <el-option label="熟练" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合BMI分类">
                  <el-select v-model="addData.dimBmi" multiple placeholder="不选则不限">
                    <el-option label="正常(<24.9)" value="A"></el-option>
                    <el-option label="超重(25-29.9)" value="B"></el-option>
                    <el-option label="肥胖(30-34.9)" value="C"></el-option>
                    <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                    <el-option label="极度肥胖(≥40)" value="E"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="submitLoading" @click="TrainPlanDatabaseInsert()" >确定</el-button>
              <el-button @click="dialogAdd = false">取消</el-button>
            </div>
          </el-dialog>
          <!-- 新增计划 End -->

          <!-- 编辑计划 -->
          <el-dialog title="编辑计划" :visible.sync="dialogEdit" width="720px" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
            <div class="addUser_body">
              <el-form ref="userMsg" :model="editData" label-width="150px">
                <el-form-item label="训练计划分类" :required=true>
                  <el-select v-model="editData.trainPlanClassification" placeholder="训练计划分类">
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划类型" :required=true>
                  <el-select v-model="editData.trainPlanType" multiple placeholder="训练计划类型">
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划难度" :required=true>
                  <el-select v-model="editData.trainPlanDifficulty" placeholder="训练计划难度">
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="训练计划名称" :required=true>
                  <el-input v-model="editData.trainPlanName" placeholder="请输入训练计划名称"></el-input>
                </el-form-item>
                <el-form-item label="列表封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditTrainPlanIconUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="editData.trainPlanIconUi || editData.trainPlanIcon" :src="editData.trainPlanIconUi || getImageUrl(editData.trainPlanIcon)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="详情页封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditTrainPlanIconDetailsUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="editData.trainPlanIconDetailsUi || editData.trainPlanIconDetails" :src="editData.trainPlanIconDetailsUi || getImageUrl(editData.trainPlanIconDetails)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="Banner封面" :required=true>
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditTrainPlanIconBannerUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true">
                    <img v-if="editData.trainPlanIconBannerUi || editData.trainPlanIconBanner" :src="editData.trainPlanIconBannerUi || getImageUrl(editData.trainPlanIconBanner)" class="cover-image">
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="每周训练次数" :required=true>
                  <el-input v-model="editData.trainPlanWeekNum" placeholder="请输入每周训练次数">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">是</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="训练计划时长" :required=true>
                  <el-input v-model="editData.trainPlanTime" placeholder="请输入训练计划时长">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">是</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="训练计划简介" :required=true>
                  <el-input type="textarea" v-model="editData.trainPlanInfo" placeholder="请输入训练计划简介"></el-input>
                </el-form-item>
                <el-form-item label="首页推荐" :required=true>
                  <el-select v-model="editData.isHome" placeholder="首页推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Banner推荐" :required=true>
                  <el-select v-model="editData.isBanner" placeholder="Banner推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐标题" :required=true>
                  <el-input v-model="editData.bannerTitle" placeholder="请输入推荐标题"></el-input>
                </el-form-item>
                <el-form-item label="推荐描述" :required=true>
                  <el-input type="textarea" v-model="editData.bannerDescription" placeholder="请输入推荐描述"></el-input>
                </el-form-item>
                <el-divider content-position="left">运动处方标签</el-divider>
                <el-form-item label="适合性别">
                  <el-select v-model="editData.dimSex" multiple placeholder="不选则不限">
                    <el-option label="男" value="A"></el-option>
                    <el-option label="女" value="B"></el-option>
                    <el-option label="秘密" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合年龄段">
                  <el-select v-model="editData.dimAge" multiple placeholder="不选则不限">
                    <el-option label="少年(6-13)" value="A"></el-option>
                    <el-option label="青年(14-17)" value="B"></el-option>
                    <el-option label="成年(18-40)" value="C"></el-option>
                    <el-option label="大师(41-64)" value="D"></el-option>
                    <el-option label="银发(65+)" value="E"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练经验">
                  <el-select v-model="editData.dimExperience" multiple placeholder="不选则不限">
                    <el-option label="新手(<2月)" value="A"></el-option>
                    <el-option label="入门(2-6月)" value="B"></el-option>
                    <el-option label="熟练(6-12月)" value="C"></el-option>
                    <el-option label="进阶(>2年)" value="D"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练频率">
                  <el-select v-model="editData.dimFrequency" multiple placeholder="不选则不限">
                    <el-option label="低频(1-2次/周)" value="A"></el-option>
                    <el-option label="常规(3-4次/周)" value="B"></el-option>
                    <el-option label="高频(5+次/周)" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合训练强度">
                  <el-select v-model="editData.dimIntensity" multiple placeholder="不选则不限">
                    <el-option label="低强" value="A"></el-option>
                    <el-option label="中强" value="B"></el-option>
                    <el-option label="高强" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合技术熟练度">
                  <el-select v-model="editData.dimSkill" multiple placeholder="不选则不限">
                    <el-option label="无基础" value="A"></el-option>
                    <el-option label="基础" value="B"></el-option>
                    <el-option label="熟练" value="C"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="适合BMI分类">
                  <el-select v-model="editData.dimBmi" multiple placeholder="不选则不限">
                    <el-option label="正常(<24.9)" value="A"></el-option>
                    <el-option label="超重(25-29.9)" value="B"></el-option>
                    <el-option label="肥胖(30-34.9)" value="C"></el-option>
                    <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                    <el-option label="极度肥胖(≥40)" value="E"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="submitLoading" @click="TrainPlanDatabaseUpdate()" >确定</el-button>
              <el-button @click="dialogEdit = false">取消</el-button>
            </div>
          </el-dialog>
          <!-- 编辑计划 End -->

          <!-- 批量新增弹窗 -->
          <el-dialog title="批量新增训练计划" :visible.sync="dialogBatchAdd" fullscreen class="batch-dialog" :close-on-click-modal="false">
            <div class="batch-add-container">
              <div class="batch-toolbar">
                <el-button type="primary" @click="addBatchRow" icon="el-icon-plus">添加一行</el-button>
                <el-button type="warning" @click="clearBatchData" icon="el-icon-delete">清空</el-button>
                <span class="batch-tip">提示：表格支持直接编辑，必填字段不能为空</span>
              </div>

              <el-table :data="batchData" border stripe class="batch-table" height="calc(100vh - 190px)">
                <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>

                <el-table-column label="训练计划分类" min-width="160">
                  <template slot="header">
                    <span class="required-field">训练计划分类</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.trainPlanClassification" placeholder="选择" size="small" style="width: 100%">
                      <el-option v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="训练计划类型" min-width="180">
                  <template slot="header">
                    <span class="required-field">训练计划类型</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.trainPlanType" multiple placeholder="选择" size="small" style="width: 100%">
                      <el-option v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="训练计划难度" min-width="160">
                  <template slot="header">
                    <span class="required-field">训练计划难度</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.trainPlanDifficulty" placeholder="选择" size="small" style="width: 100%">
                      <el-option v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="训练计划名称" min-width="220">
                  <template slot="header">
                    <span class="required-field">训练计划名称</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.trainPlanName" placeholder="必填" size="small"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="列表封面" min-width="140">
                  <template slot="header">
                    <span class="required-field">列表封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIcon')"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="scope.row.trainPlanIconUi || scope.row.trainPlanIcon" :src="scope.row.trainPlanIconUi || getImageUrl(scope.row.trainPlanIcon)" class="batch-preview-image">
                      <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="详情页封面" min-width="140">
                  <template slot="header">
                    <span class="required-field">详情页封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIconDetails')"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="scope.row.trainPlanIconDetailsUi || scope.row.trainPlanIconDetails" :src="scope.row.trainPlanIconDetailsUi || getImageUrl(scope.row.trainPlanIconDetails)" class="batch-preview-image">
                      <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="Banner封面" min-width="140">
                  <template slot="header">
                    <span class="required-field">Banner封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIconBanner')"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="scope.row.trainPlanIconBannerUi || scope.row.trainPlanIconBanner" :src="scope.row.trainPlanIconBannerUi || getImageUrl(scope.row.trainPlanIconBanner)" class="batch-preview-image">
                      <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="每周训练次数" min-width="130">
                  <template slot="header">
                    <span class="required-field">每周训练次数</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.trainPlanWeekNum" placeholder="次" size="small" type="number"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="训练计划时长(分钟)" min-width="150">
                  <template slot="header">
                    <span class="required-field">训练计划时长(分钟)</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.trainPlanTime" placeholder="分钟" size="small" type="number"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="训练计划简介" min-width="220">
                  <template slot="header">
                    <span class="required-field">训练计划简介</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.trainPlanInfo" placeholder="训练计划简介" size="small" type="textarea" :rows="2"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="首页推荐" min-width="120">
                  <template slot="header">
                    <span class="required-field">首页推荐</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.isHome" placeholder="选择" size="small" style="width: 100%">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="Banner推荐" min-width="130">
                  <template slot="header">
                    <span class="required-field">Banner推荐</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.isBanner" placeholder="选择" size="small" style="width: 100%">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="推荐标题" min-width="200">
                  <template slot="header">
                    <span class="required-field">推荐标题</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.bannerTitle" placeholder="推荐标题" size="small"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="推荐描述" min-width="200">
                  <template slot="header">
                    <span class="required-field">推荐描述</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.bannerDescription" placeholder="推荐描述" size="small" type="textarea" :rows="2"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="适合性别" min-width="160">
                  <template slot="header">
                    <span>适合性别</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimSex" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="男" value="A"></el-option>
                      <el-option label="女" value="B"></el-option>
                      <el-option label="秘密" value="C"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合年龄段" min-width="200">
                  <template slot="header">
                    <span>适合年龄段</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimAge" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="少年(6-13)" value="A"></el-option>
                      <el-option label="青年(14-17)" value="B"></el-option>
                      <el-option label="成年(18-40)" value="C"></el-option>
                      <el-option label="大师(41-64)" value="D"></el-option>
                      <el-option label="银发(65+)" value="E"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合训练经验" min-width="200">
                  <template slot="header">
                    <span>适合训练经验</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimExperience" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="新手(<2月)" value="A"></el-option>
                      <el-option label="入门(2-6月)" value="B"></el-option>
                      <el-option label="熟练(6月-2年)" value="C"></el-option>
                      <el-option label="进阶(2年+)" value="D"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合训练频率" min-width="200">
                  <template slot="header">
                    <span>适合训练频率</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimFrequency" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="低频(1-2次/周)" value="A"></el-option>
                      <el-option label="常规(3-4次/周)" value="B"></el-option>
                      <el-option label="高频(5+次/周)" value="C"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合训练强度" min-width="180">
                  <template slot="header">
                    <span>适合训练强度</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimIntensity" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="低强度" value="A"></el-option>
                      <el-option label="中强度" value="B"></el-option>
                      <el-option label="高强度" value="C"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合技术熟练度" min-width="190">
                  <template slot="header">
                    <span>适合技术熟练度</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimSkill" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="无基础" value="A"></el-option>
                      <el-option label="基础" value="B"></el-option>
                      <el-option label="熟练" value="C"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="适合BMI分类" min-width="220">
                  <template slot="header">
                    <span>适合BMI分类</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.dimBmi" multiple placeholder="未选不限" size="small" style="width: 100%">
                      <el-option label="正常(<24.9)" value="A"></el-option>
                      <el-option label="超重(25-29.9)" value="B"></el-option>
                      <el-option label="肥胖(30-34.9)" value="C"></el-option>
                      <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                      <el-option label="极度肥胖(≥40)" value="E"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="操作" min-width="130" fixed="right" align="center">
                  <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-copy-document" size="mini" circle @click="copyBatchRow(scope.$index)"></el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteBatchRow(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="success" @click="saveBatchData" :loading="batchLoading" icon="el-icon-check">保存全部</el-button>
              <el-button @click="dialogBatchAdd = false">取消</el-button>
            </div>
          </el-dialog>
          <!-- 批量新增弹窗 End -->

          <!-- 翻译管理 -->
          <i18n-translation-dialog
            :visible.sync="dialogI18n"
            :entity-type="i18nEntityType"
            :entity-id="i18nEntityId"
            :fields="i18nFields">
          </i18n-translation-dialog>
          <!-- 翻译管理 End -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import UploadExcel from '../components/UploadExcel.vue'
import WebTwoTrainPlanDatabaseSub from '@/componentsSubVue/WebTwoTrainPlanDatabaseSub.vue'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    UploadExcel,
    WebTwoTrainPlanDatabaseSub,
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      aptustwoGvListCourseType:[],
      aptustwoGvListCourseDifficulty:[],
      aptustwoGvListCourseTimeType:[],
      aptustwoGvListBodyType:[],
      aptustwoGvListMuscleRoup:[],
      aptustwoGvListAccessories:[],
      aptustwoGvListTrainPlanClassification:[],
      aptustwoGvListTrainPlanType:[],
      queryData: {
        trainPlanClassification: '0',
        trainPlanName: '',
        trainPlanDifficulty: '0',
        trainPlanType: '0',
        isHome: '-1',
        isBanner: '-1'
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        trainPlanClassification: '2',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanDifficulty: '',
        trainPlanType: [],
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: '',
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/file',
      uploadLoading: false,
      submitLoading: false,
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        trainPlanClassification: '2',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanDifficulty: '',
        trainPlanType: [],
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: '',
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      },
      allowChangeTab: false,
      TabSecondTitle:'安排周日程',
      // 批量新增
      dialogBatchAdd: false,
      batchData: [],
      batchLoading: false,
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'TRAIN_PLAN',
      i18nFields: [
        { name: 'train_plan_name', label: '计划名称', type: 'input' },
        { name: 'train_plan_info', label: '计划简介', type: 'textarea' },
        { name: 'banner_title', label: '推荐标题', type: 'input' },
        { name: 'banner_description', label: '推荐描述', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  watch: {
    dialogI18n(val) {
      if (!val) {
        this.loadTranslations('TRAIN_PLAN', this.dataList, 'id')
      }
    }
  },
  mounted () {
    this.aptustwoGvListCourseType = JSON.parse(localStorage.getItem('aptustwoGvListCourseType'));
    this.aptustwoGvListCourseDifficulty = JSON.parse(localStorage.getItem('aptustwoGvListCourseDifficulty'));
    this.aptustwoGvListCourseTimeType = JSON.parse(localStorage.getItem('aptustwoGvListCourseTimeType'));
    this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'));
    this.aptustwoGvListMuscleRoup = JSON.parse(localStorage.getItem('aptustwoGvListMuscleRoup'));
    this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'));
    this.aptustwoGvListTrainPlanClassification = JSON.parse(localStorage.getItem('aptustwoGvListTrainPlanClassification'));
    this.aptustwoGvListTrainPlanType = JSON.parse(localStorage.getItem('aptustwoGvListTrainPlanType'));
    this.TrainPlanDatabaseList()
    this.TrainPlanDatabaseNum()
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      const leftProps = ['trainPlanName']
      const leftLabels = ['计划名称', '英文名称', '德文名称']
      if (leftProps.includes(column.property) || leftLabels.includes(column.label)) {
        return { textAlign: 'left' }
      }
      return { textAlign: 'center' }
    },
    BackToFirst (val) {
      this.activeName = 'first'
      this.TabSecondTitle = '安排周日程'
      this.TrainPlanDatabaseList()
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first") {
        this.$message.warning('禁止点击');
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
        if (that.$refs.trainPlanTable) {
          that.$refs.trainPlanTable.doLayout()
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    tableIndexMethod (index) {
      const seq = (this.page_no - 1) * this.page_size + index + 1
      if (this.sortOrder === 'asc') {
        return seq
      }
      return this.dataListnum - seq + 1
    },
    handleSortChange ({ prop, order }) {
      const fieldMap = {
        'trainPlanTypeUi': 'trainPlanType',
        'trainPlanDifficultyUi': 'trainPlanDifficulty'
      }
      this.sortField = fieldMap[prop] || prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    clickQueryReset () {
      this.queryData.trainPlanClassification = '0'
      this.queryData.trainPlanName = ''
      this.queryData.trainPlanDifficulty = '0'
      this.queryData.trainPlanType = '0'
      this.queryData.isHome = '-1'
      this.queryData.isBanner = '-1'
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.trainPlanClassification = '2'
      this.addData.trainPlanWeekNum = '0'
      this.addData.trainPlanTime = '0'
      this.addData.trainPlanName = ''
      this.addData.trainPlanIcon = ''
      this.addData.trainPlanIconUi = ''
      this.addData.trainPlanIconDetails = ''
      this.addData.trainPlanIconDetailsUi = ''
      this.addData.trainPlanIconBanner = ''
      this.addData.trainPlanIconBannerUi = ''
      this.addData.trainPlanDifficulty = ''
      this.addData.trainPlanType = []
      this.addData.trainPlanInfo = ''
      this.addData.isHome = '0'
      this.addData.isBanner = '0'
      this.addData.bannerTitle = ''
      this.addData.bannerDescription = ''
      this.addData.dimSex = []
      this.addData.dimAge = []
      this.addData.dimExperience = []
      this.addData.dimFrequency = []
      this.addData.dimIntensity = []
      this.addData.dimSkill = []
      this.addData.dimBmi = []
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.trainPlanClassification = row.trainPlanClassification.toString()
      this.editData.trainPlanWeekNum = row.trainPlanWeekNum
      this.editData.trainPlanTime = row.trainPlanTime
      this.editData.trainPlanName = row.trainPlanName
      this.editData.trainPlanIcon = row.trainPlanIcon
      this.editData.trainPlanIconUi = row.trainPlanIconUi
      this.editData.trainPlanIconDetails = row.trainPlanIconDetails
      this.editData.trainPlanIconDetailsUi = row.trainPlanIconDetailsUi
      this.editData.trainPlanIconBanner = row.trainPlanIconBanner
      this.editData.trainPlanIconBannerUi = row.trainPlanIconBannerUi
      this.editData.trainPlanDifficulty = row.trainPlanDifficulty.toString()
      this.editData.trainPlanType = Vue.prototype.ConvertStringToArray(row.trainPlanType)
      this.editData.trainPlanInfo = row.trainPlanInfo
      this.editData.isHome = row.isHome.toString()
      this.editData.isBanner = row.isBanner.toString()
      this.editData.bannerTitle = row.bannerTitle
      this.editData.bannerDescription = row.bannerDescription
      this.editData.dimSex = []
      this.editData.dimAge = []
      this.editData.dimExperience = []
      this.editData.dimFrequency = []
      this.editData.dimIntensity = []
      this.editData.dimSkill = []
      this.editData.dimBmi = []
      this.loadPrescriptionTag(2, row.id)
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除？').then(function () {
        that.TrainPlanDatabaseDelete(row.id)
      })
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    gotoWebTwoTrainPlanDatabaseSub(row){
      this.activeName = 'second'
      this.allowChangeTab = true
      this.TabSecondTitle = '安排周日程 - 【' + row.trainPlanName + '】'
      this.$nextTick(() => {
        this.$refs.SubVuesecond && this.$refs.SubVuesecond.LoadData(row)
      })
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.TrainPlanDatabaseList()
        this.TrainPlanDatabaseNum()
      }
    },
    TrainPlanDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.queryData.trainPlanClassification
      data.trainPlanName = that.queryData.trainPlanName
      data.trainPlanDifficulty = that.queryData.trainPlanDifficulty
      data.trainPlanType = that.queryData.trainPlanType
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('TRAIN_PLAN', that.dataList, 'id')
          }
          that.$nextTick(that.calcTableHeight)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.queryData.trainPlanClassification
      data.trainPlanName = that.queryData.trainPlanName
      data.trainPlanDifficulty = that.queryData.trainPlanDifficulty
      data.trainPlanType = that.queryData.trainPlanType
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.addData.trainPlanClassification
      data.trainPlanWeekNum = that.addData.trainPlanWeekNum
      data.trainPlanTime = that.addData.trainPlanTime
      data.trainPlanName = that.addData.trainPlanName
      data.trainPlanIcon = that.addData.trainPlanIcon
      data.trainPlanIconDetails = that.addData.trainPlanIconDetails
      data.trainPlanIconBanner = that.addData.trainPlanIconBanner
      data.trainPlanDifficulty = that.addData.trainPlanDifficulty
      data.trainPlanType = Vue.prototype.ConvertArrayToString(that.addData.trainPlanType)
      data.trainPlanInfo = that.addData.trainPlanInfo
      data.isHome = that.addData.isHome
      data.isBanner = that.addData.isBanner
      data.bannerTitle = that.addData.bannerTitle
      data.bannerDescription = that.addData.bannerDescription
      data.dimSex = that.addData.dimSex ? that.addData.dimSex.join(',') : ''
      data.dimAge = that.addData.dimAge ? that.addData.dimAge.join(',') : ''
      data.dimExperience = that.addData.dimExperience ? that.addData.dimExperience.join(',') : ''
      data.dimFrequency = that.addData.dimFrequency ? that.addData.dimFrequency.join(',') : ''
      data.dimIntensity = that.addData.dimIntensity ? that.addData.dimIntensity.join(',') : ''
      data.dimSkill = that.addData.dimSkill ? that.addData.dimSkill.join(',') : ''
      data.dimBmi = that.addData.dimBmi ? that.addData.dimBmi.join(',') : ''
      data.sign = Vue.prototype.FunGetSign(data)
      that.submitLoading = true
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseInsert, Qs.stringify(data))
        .then(function (response) {
          that.submitLoading = false
          if (response.data.code === 1) {
            that.$message.success('新增成功')
            that.page_no = 1
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
            that.dialogAdd = false
          } else {
            Vue.prototype.FunRemindOnlyError(response.data)
          }
        })
        .catch(function (error) {
          that.submitLoading = false
          console.log(error)
          that.dialogAdd = false
        })
    },
    TrainPlanDatabaseUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.trainPlanClassification = that.editData.trainPlanClassification
      data.trainPlanWeekNum = that.editData.trainPlanWeekNum
      data.trainPlanTime = that.editData.trainPlanTime
      data.trainPlanName = that.editData.trainPlanName
      data.trainPlanIcon = that.editData.trainPlanIcon
      data.trainPlanIconDetails = that.editData.trainPlanIconDetails
      data.trainPlanIconBanner = that.editData.trainPlanIconBanner
      data.trainPlanDifficulty = that.editData.trainPlanDifficulty
      data.trainPlanType = Vue.prototype.ConvertArrayToString(that.editData.trainPlanType)
      data.trainPlanInfo = that.editData.trainPlanInfo
      data.isHome = that.editData.isHome
      data.isBanner = that.editData.isBanner
      data.bannerTitle = that.editData.bannerTitle
      data.bannerDescription = that.editData.bannerDescription
      data.sign = Vue.prototype.FunGetSign(data)
      that.submitLoading = true
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseUpdate, Qs.stringify(data))
        .then(function (response) {
          that.submitLoading = false
          if (response.data.code === 1) {
            that.$message.success('编辑成功')
            that.dialogEdit = false
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
            that.savePrescriptionTag(2, that.editData.id)
          } else {
            Vue.prototype.FunRemindOnlyError(response.data)
          }
        })
        .catch(function (error) {
          that.submitLoading = false
          console.log(error)
          that.dialogEdit = false
        })
    },
    TrainPlanDatabaseDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      that.submitLoading = true
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseDelete, Qs.stringify(data))
        .then(function (response) {
          that.submitLoading = false
          if (response.data.code === 1) {
            that.$message.success('删除成功')
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
          } else {
            Vue.prototype.FunRemindOnlyError(response.data)
          }
        })
        .catch(function (error) {
          that.submitLoading = false
          console.log(error)
        })
    },
    // 图片上传前校验
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    // 新增-列表封面上传
    handleAddTrainPlanIconUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIcon', 'images/trainplan/')
    },
    // 新增-详情页封面上传
    handleAddTrainPlanIconDetailsUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIconDetails', 'images/trainplan/')
    },
    // 新增-Banner封面上传
    handleAddTrainPlanIconBannerUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIconBanner', 'images/trainplan/')
    },
    // 编辑-列表封面上传
    handleEditTrainPlanIconUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIcon', 'images/trainplan/')
    },
    // 编辑-详情页封面上传
    handleEditTrainPlanIconDetailsUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIconDetails', 'images/trainplan/')
    },
    // 编辑-Banner封面上传
    handleEditTrainPlanIconBannerUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIconBanner', 'images/trainplan/')
    },
    // 通用文件上传处理
    handleFileUpload (options, type, field, category) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 显示 loading
      that.uploadLoading = true
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', category)
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        that.uploadLoading = false
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          const targetData = type === 'add' ? that.addData : that.editData
          const uiField = field + 'Ui'
          // 使用$set确保响应式更新
          that.$set(targetData, field, response.data.data.relativeUrl)
          that.$set(targetData, uiField, response.data.data.absoluteUrl)
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        that.uploadLoading = false
        console.log(error)
        that.$message.error('上传失败')
        options.onError(error)
      })
    },
    // 图片URL处理
    getImageUrl (url) {
      if (!url) return ''
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url
    },
    // 批量新增 - 打开弹窗
    clickBatchAdd () {
      this.dialogBatchAdd = true
      // 默认添加一行
      if (this.batchData.length === 0) {
        this.addBatchRow()
      }
    },
    // 批量新增 - 添加一行
    addBatchRow () {
      this.batchData.push({
        trainPlanClassification: '2',
        trainPlanType: [],
        trainPlanDifficulty: '',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: '',
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      })
    },
    // 批量新增 - 删除一行
    deleteBatchRow (index) {
      this.$deleteConfirm('确定删除该行数据？').then(() => {
        this.batchData.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    // 批量新增 - 复制一行
    copyBatchRow (index) {
      var newRow = JSON.parse(JSON.stringify(this.batchData[index]))
      this.batchData.splice(index + 1, 0, newRow)
      this.$message.success('复制成功')
    },
    // 批量新增 - 清空
    clearBatchData () {
      this.$deleteConfirm('确定清空所有数据？').then(() => {
        this.batchData = []
        this.$message.success('清空成功')
      }).catch(() => {})
    },
    // 批量新增 - 图片上传
    handleBatchIconUpload (options, index, field) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)

      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'

      // 添加文件
      formData.append('file', options.file)

      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/trainplan/')

      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          const uiField = field + 'Ui'
          // 同时更新原字段和Ui字段
          that.batchData[index][field] = response.data.data.relativeUrl
          that.batchData[index][uiField] = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败')
        options.onError(error)
      })
    },
    // 批量新增 - 保存数据
    saveBatchData () {
      var that = this

      if (that.batchData.length === 0) {
        that.$message.warning('请至少添加一行数据')
        return
      }

      // 验证必填字段
      for (let i = 0; i < that.batchData.length; i++) {
        const row = that.batchData[i]
        const rowNum = i + 1

        // 训练计划分类
        if (!row.trainPlanClassification) {
          that.$message.error(`第${rowNum} 行：请选择训练计划分类`)
          return
        }

        // 训练计划类型
        if (!row.trainPlanType || row.trainPlanType.length === 0) {
          that.$message.error(`第${rowNum} 行：请选择训练计划类型`)
          return
        }

        // 训练计划难度
        if (!row.trainPlanDifficulty) {
          that.$message.error(`第${rowNum} 行：请选择训练计划难度`)
          return
        }

        // 训练计划名称
        if (!row.trainPlanName || row.trainPlanName.trim() === '') {
          that.$message.error(`第${rowNum} 行：训练计划名称不能为空`)
          return
        }

        // 列表封面
        if (!row.trainPlanIcon || row.trainPlanIcon.trim() === '') {
          that.$message.error(`第${rowNum} 行：请上传列表封面`)
          return
        }

        // 训练计划难度
        if (!row.trainPlanIconDetails || row.trainPlanIconDetails.trim() === '') {
          that.$message.error(`第${rowNum} 行：请上传详情页封面`)
          return
        }

        // Banner封面
        if (!row.trainPlanIconBanner || row.trainPlanIconBanner.trim() === '') {
          that.$message.error(`第${rowNum} 行：请上传Banner封面`)
          return
        }

        // 每周训练次数
        if (!row.trainPlanWeekNum || row.trainPlanWeekNum === '' || row.trainPlanWeekNum <= 0) {
          that.$message.error(`第${rowNum} 行：请输入有效的每周训练次数`)
          return
        }

        // 训练计划时长
        if (!row.trainPlanTime || row.trainPlanTime === '' || row.trainPlanTime <= 0) {
          that.$message.error(`第${rowNum} 行：请输入有效的训练计划时长`)
          return
        }

        // 训练计划简介
        if (!row.trainPlanInfo || row.trainPlanInfo.trim() === '') {
          that.$message.error(`第${rowNum} 行：请输入训练计划简介`)
          return
        }

        // 首页推荐
        if (row.isHome === undefined || row.isHome === null) {
          that.$message.error(`第${rowNum} 行：请选择首页推荐`)
          return
        }

        // Banner推荐
        if (row.isBanner === undefined || row.isBanner === null) {
          that.$message.error(`第${rowNum} 行：请选择Banner推荐`)
          return
        }

        // 推荐标题
        if (!row.bannerTitle || row.bannerTitle.trim() === '') {
          that.$message.error(`第${rowNum} 行：请输入推荐标题`)
          return
        }

        // 推荐描述
        if (!row.bannerDescription || row.bannerDescription.trim() === '') {
          that.$message.error(`第${rowNum} 行：请输入推荐描述`)
          return
        }

      }

      // 构建请求数据
      const trainPlanList = that.batchData.map(row => {
        return {
          trainPlanClassification: parseInt(row.trainPlanClassification) || 0,
          trainPlanType: Vue.prototype.ConvertArrayToString(row.trainPlanType),
          trainPlanDifficulty: parseInt(row.trainPlanDifficulty) || 0,
          trainPlanName: row.trainPlanName,
          trainPlanIcon: row.trainPlanIcon,
          trainPlanIconDetails: row.trainPlanIconDetails,
          trainPlanIconBanner: row.trainPlanIconBanner,
          trainPlanWeekNum: parseInt(row.trainPlanWeekNum) || 0,
          trainPlanTime: parseInt(row.trainPlanTime) || 0,
          trainPlanInfo: row.trainPlanInfo,
          isHome: parseInt(row.isHome) || 0,
          isBanner: parseInt(row.isBanner) || 0,
          bannerTitle: row.bannerTitle,
          bannerDescription: row.bannerDescription,
          dimSex: row.dimSex ? row.dimSex.join(',') : '',
          dimAge: row.dimAge ? row.dimAge.join(',') : '',
          dimExperience: row.dimExperience ? row.dimExperience.join(',') : '',
          dimFrequency: row.dimFrequency ? row.dimFrequency.join(',') : '',
          dimIntensity: row.dimIntensity ? row.dimIntensity.join(',') : '',
          dimSkill: row.dimSkill ? row.dimSkill.join(',') : '',
          dimBmi: row.dimBmi ? row.dimBmi.join(',') : ''
        }
      })

      that.batchLoading = true

      // 构建请求体
      const requestBody = {
        tempUuid: localStorage.getItem('tempUuid'),
        trainPlanList: trainPlanList
      }

      // 打印请求数据用于调试
      console.log('=== 批量新增请求信息 ===')
      console.log('tempUuid:', requestBody.tempUuid)
      console.log('trainPlanList长度:', trainPlanList.length)
      console.log('完整请求体', JSON.stringify(requestBody, null, 2))

      // 使用 JSON 格式发送
      axios.post(Vue.prototype.global.Url_Base + 'TrainPlanDatabase/batchInsert', requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        that.batchLoading = false
        if (response.data.code === 1) {
          that.$message.success('批量新增成功！共 ' + that.batchData.length + ' 条数据')
          that.dialogBatchAdd = false
          that.batchData = []
          that.page_no = 1
          that.TrainPlanDatabaseList()
          that.TrainPlanDatabaseNum()
        } else {
          that.$message.error('批量新增失败' + response.data.message)
        }
      }).catch(function (error) {
        that.batchLoading = false
        console.log(error)
        that.$message.error('批量新增失败')
      })
    },
    // 加载处方标签
    loadPrescriptionTag (targetType, targetId) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.targetType = targetType
      data.targetId = targetId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_Base + 'WebTwoPrescriptionTag/get', { params: data })
        .then(function (response) {
          if (response.data.code === 1 && response.data.data) {
            var tag = response.data.data
            that.editData.dimSex = tag.dimSex ? tag.dimSex.split(',') : []
            that.editData.dimAge = tag.dimAge ? tag.dimAge.split(',') : []
            that.editData.dimExperience = tag.dimExperience ? tag.dimExperience.split(',') : []
            that.editData.dimFrequency = tag.dimFrequency ? tag.dimFrequency.split(',') : []
            that.editData.dimIntensity = tag.dimIntensity ? tag.dimIntensity.split(',') : []
            that.editData.dimSkill = tag.dimSkill ? tag.dimSkill.split(',') : []
            that.editData.dimBmi = tag.dimBmi ? tag.dimBmi.split(',') : []
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 保存处方标签
    savePrescriptionTag (targetType, targetId) {
      var that = this
      var sourceData = that.editData
      var data = Vue.prototype.FunGetBaseSignData()
      data.targetType = targetType
      data.targetId = targetId
      data.dimSex = sourceData.dimSex ? sourceData.dimSex.join(',') : ''
      data.dimAge = sourceData.dimAge ? sourceData.dimAge.join(',') : ''
      data.dimExperience = sourceData.dimExperience ? sourceData.dimExperience.join(',') : ''
      data.dimFrequency = sourceData.dimFrequency ? sourceData.dimFrequency.join(',') : ''
      data.dimIntensity = sourceData.dimIntensity ? sourceData.dimIntensity.join(',') : ''
      data.dimSkill = sourceData.dimSkill ? sourceData.dimSkill.join(',') : ''
      data.dimBmi = sourceData.dimBmi ? sourceData.dimBmi.join(',') : ''
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_Base + 'WebTwoPrescriptionTag/save', Qs.stringify(data))
        .then(function (response) {
          if (response.data.code !== 1) {
            Vue.prototype.FunRemindOnlyError(response.data)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  TrainPlanDatabaseManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.train-plan-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 训练计划表格 */
.train-plan-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--warning:hover {
      background-color: var(--aptus-accent-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 辅助文字 */
.text-muted {
  color: var(--aptus-text-muted);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .train-plan-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: var(--aptus-surface-muted);
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

/deep/ .el-button--success {
  color: #FFF;
  background-color: var(--aptus-success);
  border-color: var(--aptus-success);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3d9c42;
    border-color: #3d9c42;
    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.25);
  }
}

// 上传组件样式
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed var(--aptus-border);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: var(--aptus-primary-light);
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: var(--aptus-text-muted);
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: var(--aptus-text-muted);
  margin-top: 8px;
}

// 批量新增弹窗样式
.batch-dialog {
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-dialog__header {
    padding: 15px 20px;
    background: var(--aptus-surface-muted);
    border-bottom: 1px solid var(--aptus-border-light);
    flex-shrink: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    text-align: center;
    border-top: 1px solid var(--aptus-border-light);
    flex-shrink: 0;
  }
}

// 批量新增样式
.batch-add-container {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.batch-toolbar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  .batch-tip {
    color: var(--aptus-text-muted);
    font-size: 14px;
    margin-left: 20px;
  }
}

.batch-table {
  flex: 1;
  min-height: 0;
  overflow: hidden;

  /deep/ .el-table {
    height: 100% !important;
  }

  /deep/ .el-table__body-wrapper {
    overflow: auto;
  }

  /deep/ .el-input__inner {
    padding: 5px 10px;
  }

  /deep/ .el-textarea__inner {
    padding: 5px 10px;
    min-height: 50px !important;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

// 批量上传组件样式
.batch-uploader {
  /deep/ .el-upload {
    display: block;
    text-align: center;
  }
}

.batch-preview-image {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 auto;
}

// 必填字段标记
.required-field {
  &::before {
    content: '*';
    color: var(--aptus-danger);
    margin-right: 4px;
  }
}
</style>

<style scoped>
/* 隐藏 Tab Header（安排周日程为代码控制跳转，不可手动点击） */
::v-deep .el-tabs {
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs > .el-tabs__header {
  display: none;
}

::v-deep .el-tabs--border-card {
  background: transparent;
  border: none;
  box-shadow: none;
}

::v-deep .el-tabs__content {
  flex: 1;
  padding: 0;
  overflow: hidden;
}

::v-deep .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
